import { ButtonBase } from "@components/Button";
import { pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";

export const Table = styled.table`
  width: 100%;
  text-align: center;
  border-spacing: ${pxToRem(4)} ${pxToRem(5)};
  border-collapse: separate;

  /* The main column expands to fill the table area & is styled with fontPrimary. */
  .main {
    text-align: start;
  }

  col {
    width: fit-content;
  }
  col.main {
    width: auto;
  }
`;

export const THead = styled.thead`
  margin-bottom: ${pxToRem(5)};
  font-size: ${pxToRem(10)};
  letter-spacing: 0px;
  color: ${({ theme }) => theme.grey_150};
`;

export const Td = styled.td`
  background-color: white;
  font-size: ${pxToRem(14)};

  &.main {
    padding: ${pxToRem(5)};
    font-family: ${({ theme }) => theme.fontPrimary};
    font-size: ${pxToRem(14)};
    user-select: none;
    text-transform: uppercase;
    a {
      text-decoration: none;
    }
  }

  &.myEntry {
    background: ${({ theme }) =>
      `linear-gradient(180deg, ${theme.blue} 0%, white 13%, white 87%, ${theme.blue} 100%)`};
  }

  > img {
    padding: ${pxToRem(2)};
  }
`;

export const MyEntryRow = styled.tr`
  td {
    background: ${({ theme }) =>
      `linear-gradient(180deg, ${theme.blue} 0%, white 13%, white 87%, ${theme.blue} 100%)`};
  }
`;

/**
 * Uses "react-pagination" component
 */
export const PaginationArea = styled.nav`
  .pagination {
    margin: ${pxToRem(20)} 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    color: white;

    li {
      margin: 0 ${pxToRem(4)} ${pxToRem(8)};
    }

    a {
      ${ButtonBase}
      font-size: ${pxToRem(12)};
      line-height: ${pxToRem(22)};
      border: 1px solid transparent;
      min-width: ${pxToRem(20)};
    }

    .disabled a {
      opacity: 0.3;
    }

    .active a {
      border-color: ${({ theme }) => theme.gold};
    }

    .previous.disabled,
    .next.disabled {
      visibility: hidden;
    }

    [rel="prev"],
    [rel="next"] {
      width: ${pxToRem(12)};
      min-width: ${pxToRem(12)};
      margin: 0 ${pxToRem(8)};
    }
    [rel="prev"] {
      transform: rotate(180deg);
    }
  }
`;
